{
  "admin-hub.ci-test.message-template-template-hello-world": "Hola, {propA}. Esto es un {propB} encantador",
  "ci-generation.email.body": "This is a test message from the {env} environment.",
  "ci-generation.email.body.hello": "Hi {name},",
  "ci-generation.email.body.img.alt": "This is the alt text for the image",
  "ci-generation.email.body.regards": "Team Post Office",
  "ci-generation.email.body.signoff": "Regards,",
  "ci-generation.email.subject": "Post Office Test Message from {env}",
  "ci-generation.email.unsubscribe.text": "Unsubscribe",
  "post-office.test-message.email.subject": "Post Office Test Message from {env}.",
  "product-store-personal-use-case.hello-world": "Hello {propA}. Is is a lovely {propB}",
  "test-messages.app-switcher-discovery-section.dismiss": "Dismiss",
  "test-messages.app-switcher-discovery-section.test-content": "This is a test message.",
  "test-messages.email.body.regards": "Team Post Office",
  "test-messages.in-app-example.hello-world": "Hello {propA}. Is is a lovely {propB}",
  "test-messages.jira-navigation-topbar-edition-awareness.hello-world": "Hello {propA}. Is is a lovely {propB}",
  "test-messages.test-message.email.body": "This is a test message from the {env} environment. {additionalBody}",
  "test-messages.test-message.email.body.hello": "Hi Atlassian,",
  "test-messages.test-message.email.body.img.alt": "this is the alt for the test-message-email message template",
  "test-messages.test-message.email.body.signoff": "Regards,",
  "test-messages.test-message.email.unsubscribe.text": "Unsubscribe"
}